import { useQueryClient } from '@tanstack/react-query';
import { Button, Spin } from 'antd';
import apiCall from 'apps/investment/apiCalls/order';
import { usePostApi } from 'hooks/api';
import {
  orderStatusCancelled,
  orderStatusCompleted,
} from 'apps/investment/constants/fundOrder';

export const FundOrderAction = ({ order }) => {
  const queryClient = useQueryClient();

  if (!order || !order.id) {
    return null;
  }

  const { post: syncOrderStatus, isLoading } = usePostApi(apiCall.sync, {
    resourceName: 'data',
    // SubmitFundOrder persists synchronously, so refetching the order list is
    // what makes the new status visible without a full page reload.
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [apiCall.list.queryKey] });
    },
  });

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-full">
        <Spin size="large" />
      </div>
    );
  }

  if (
    order.fund_order_id ||
    order.status == orderStatusCancelled ||
    order.status == orderStatusCompleted
  ) {
    return null;
  }

  return (
    <>
      <Button
        onClick={() =>
          confirm(
            `Are you sure you want to send the order #${order.code} to Fund Manager?`
          ) && syncOrderStatus({ id: order.id })
        }
        disabled={isLoading}
        type="primary"
        style={{
          marginLeft: '10px',
          backgroundColor: 'green',
          borderColor: 'green',
        }}
      >
        Send to Fund
      </Button>
    </>
  );
};
